export default __webpack_public_path__ + "static/media/international.47ce347b.jpg";